import script from "./forgot-password.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-password.vue?vue&type=script&setup=true&lang=js"

import "./forgot-password.vue?vue&type=style&index=0&id=753427cd&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-753427cd"]])

export default __exports__